import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as io from 'socket.io-client';
import { environment } from './../../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class SocketService {
  private readonly BASE_URL = environment.socket;
  private socket: any = null;

  constructor() {}

  /**
   * description: conecta o usuários ao socket server
   */
  public connectSocket(userId: number, name: string, type: number): void {
    this.socket = io(this.BASE_URL, { query: `userId=${userId}&name=${name}&type=${type} `});
  }

  /**
   * description: emite o logout event socket server
   */
  public logout(userId: number, name: string, type: number): void {
    this.socket.emit('logout', { userId, name, type });
    this.socket.disconnect();
    /*return new Observable<any>(observer => {      
      return () => {
        null
      }
    })*/
  }
}
